import * as React from 'react';

const ClientOnly = ({children}) => {
	const [ isLoaded, setIsLoaded ] = React.useState(false);
	
	React.useEffect(() => {
		setIsLoaded(true);
	}, []);

	if (!isLoaded)return null;
	return children
}

export default ClientOnly